import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AlertSnackbar from 'components/shared/alert-snackbar/alert-snackbar.component';
import { BatchOrdersResult } from 'models/order';
import { describeFailedOrders } from './use-delivery-note-batch';

type BatchOrdersResultSnackbarProps = {
    result: BatchOrdersResult | null;
    onClose: () => void;
};

/** DD-3463: how many orders a batch action processed, and which ones failed. */
const BatchOrdersResultSnackbar: FC<BatchOrdersResultSnackbarProps> = ({
    result,
    onClose,
}: BatchOrdersResultSnackbarProps) => {
    const { t: translate } = useTranslation(['orders']);
    if (!result) {
        return null;
    }
    const succeeded = translate('orders:BATCH_RESULT_SUCCEEDED', { count: result.succeeded.length });
    if (!result.failed.length) {
        return <AlertSnackbar type="success" message={succeeded} onClose={onClose} />;
    }
    return (
        <AlertSnackbar
            type="warning"
            title={succeeded}
            message={translate('orders:BATCH_RESULT_FAILED', {
                count: result.failed.length,
                orderIds: describeFailedOrders(result.failed),
            })}
            onClose={onClose}
        />
    );
};

export default BatchOrdersResultSnackbar;
